
import { Vue, Options } from "vue-class-component";
import DownloadTemplate from "../components/DownloadTemplateVertical.vue";
import UploadFile from "@/app/ui/components/upload-file/index.vue";
import { BulkBookingController } from "@/app/ui/controllers/BulkBookingController";
import { GTMCommonEvent } from "@/app/infrastructures/misc/gtm-event/common-event";
import { bulkTemplateUrl } from "./modules/utils";
import {
  internationalTemplateUrl,
  permissionBulkBooking
} from "./modules/utils";
import SectionFilterClient from "@/app/ui/views/shipment/booking/create-booking-v2/components/section-filter-client.vue";
import { FlagsPermissionBulkBookingV2 } from "@/feature-flags/flags-bulk-booking-v2";
import { FlagsBcsBulkDownloadTemplate } from "@/feature-flags/flags-bulk-download-template";
import { AccountController } from "@/app/ui/controllers/AccountController";
import { configBucketTemplateFiles } from "@/feature-flags/flags-config-bucket-storage";

@Options({
  components: {
    DownloadTemplate,
    UploadFile,
    SectionFilterClient
  }
})
export default class BulkBooking extends Vue {
  mounted() {
    this.resetForm();
    this.form.type = this.utilsBulkBooking().permissionClient || this.utilsBulkBooking().permissionInternal ? 'client' : '';
  }

  // route navigation
  goBack() {
    this.$router.push("/shipment/bulk/bulk-v2");
  }

  get dataProfile() {
    return AccountController.accountData;
  }

  get domesticTemplateUrl(): string {
    return bulkTemplateUrl({
      audience: "client",
      scope: "domestic",
      countryCode: this.dataProfile.countryCode
    });
  }

  get internationalTemplateUrl(): string {
    return bulkTemplateUrl({
      audience: "client",
      scope: "international",
      countryCode: this.dataProfile.countryCode
    });
  }

  get templateBookingData() {
    return [
      {
        title: this.$t("bulkBooking.common.bookingInternational"),
        isButton: true,
        url: this.internationalTemplateUrl,
        permission:
          this.utilsBulkBooking().permissionClient ||
          this.utilsBulkBooking().permissionInternal ||
          this.utilsBulkBooking().permissionPosClient,
        id: "button_download_template_booking_klien",
        type: "",
        dataTestId: "bulk-booking-create-button-download-template-international"
      },
      {
        title: this.$t("bulkBooking.common.bookingDomestic"),
        isButton: true,
        url: this.domesticTemplateUrl,
        permission:
          this.utilsBulkBooking().permissionClient ||
          this.utilsBulkBooking().permissionInternal ||
          this.utilsBulkBooking().permissionPosClient,
        id: "button_download_template_booking_klien",
        type: "",
        dataTestId: "bulk-booking-create-button-download-template-domestic"
      }
    ];
  }

  get templateComodityData() {
    return [
      {
        title: this.$t("bulkBooking.common.commodityData"),
        isButton: false,
        permission:
          this.utilsBulkBooking().permissionPos ||
          this.utilsBulkBooking().permissionClient ||
          this.utilsBulkBooking().permissionInternal,
        id: "field_download_data_komoditas",
        type: "commodity/export_csv",
        dataTestId: "bulk-booking-create-link-commodity-data"
      },
      {
        title: this.$t("bulkBooking.common.districtData"),
        isButton: false,
        permission:
          this.utilsBulkBooking().permissionPos ||
          this.utilsBulkBooking().permissionClient ||
          this.utilsBulkBooking().permissionInternal,
        id: "field_download_data_kecamatan",
        type: "district/export_csv?status=ACTIVE",
        dataTestId: "bulk-booking-create-link-district-data"
      }
    ];
  }

  get maximumStt() {
    return FlagsPermissionBulkBookingV2.config_bulk_booking_v2_max_stt.getValue();
  }
  
  get maximumFileSize() {
    return FlagsPermissionBulkBookingV2.config_bulk_booking_v2_max_file_MB.getValue();
  }

  get form(): any {
    return BulkBookingController.form;
  }

  get utilsBulkBooking() {
    return permissionBulkBooking;
  }

  get isPermissionClient() {
    return this.utilsBulkBooking().permissionClient;
  }

  get isValidateType() {
    const isArchiveType =
      !this.form.type ||
      this.form.type === "Bulk Booking" ||
      (this.form.type === "client" &&
        !this.form.clientName &&
        !this.utilsBulkBooking().permissionClient);
    return isArchiveType;
  }

  get isBulkUploadValid() {
    return (
      !this.form.activityName ||
      this.form.activityName.length < 3 ||
      typeof this.form.archiveFile !== "object" ||
      this.isValidateType
    );
  }

  get messageModalBookingOnProcess() {
    return this.$t("bulkBooking.create.modalProcessingMessage", {
      name: this.activityNameBooking
    });
  }

  get messageModalBookingFailedUpload() {
    return `Proses booking "${this.activityNameBooking}" belum berhasil, upload ulang file anda.`;
  }

  modalMessageSuccess(data: any) {
    return data?.success && data?.message === "uploading";
  }

  activityNameBooking = "";
  onChangeActivityName(value: string) {
    this.activityNameBooking = value;
  }

  getBookingType(value: string) {
    this.form.type = value;
    this.form.clientName = "";
  }

  resultUpload = false;
  resultErrorUpload = false;
  errorTitle = "";
  errorSubtitle = "";
  btnModalFailed = "";
  btnModalCancel = "";
  errorCode = 0;
  async _onAdd() {
    const resp = await BulkBookingController.uploadBulkBooking({
      activityName: this.form.activityName,
      archiveFile: this.form.archiveFile,
      posClientId:
        this.form.type === "client" && !this.utilsBulkBooking().permissionClient
          ? this.form.clientName.id
          : this.utilsBulkBooking().idAccount,
      posClientType: this.form.type === "client" ? "client" : "pos",
      templateFormat:
        this.form.type === "client" ? "client_template" : "genesis_template",
      versionType: "stt-v2"
    });

    if (this.modalMessageSuccess(resp)) {
      this.resultUpload = true;
      this.resetForm();
    } else {
      const statusCode = resp.response.data?.code;
      this.errorConditionModal(statusCode);
    }
    GTMCommonEvent("upload_bulk_booking_upload_clicked");
  }

  errorConditionModal(codeResp: number) {
    const statusCode = codeResp >= 100 && codeResp <= 104;
    const titleError: any = {
      "100": this.$t("bulkBooking.create.modalErrorRowEmpty"),
      "101": this.$t("bulkBooking.create.modalErrorDataExceed", {
        maxStt: this.maximumStt
      }),
      "102": this.$t("bulkBooking.create.modalErrorHeaderInvalid"),
      "103": this.$t("bulkBooking.create.modalErrorRowEmptyAlt"),
      "104": this.$t("bulkBooking.create.modalErrorQueueFull"),
      "105": this.$t("bulkBooking.create.modalErrorFileSize", {size: this.maximumFileSize}),
      "default": this.$t("bulkBooking.create.modalErrorSystem")
    };

    const subtitleError: any = {
      "100": this.$t("bulkBooking.create.modalSubtitleRowEmpty"),
      "101": this.$t("bulkBooking.create.modalSubtitleDataExceed"),
      "102": this.$t("bulkBooking.create.modalSubtitleHeaderInvalid"),
      "103": this.$t("bulkBooking.create.modalSubtitleRowEmptyAlt"),
      "104": this.$t("bulkBooking.create.modalSubtitleQueueFull"),
      "105": this.$t("bulkBooking.create.modalSubtitleFileSize"),
      "default": this.$t("bulkBooking.create.modalSubtitleSystem")
    }

    this.errorTitle = titleError[`${codeResp}`] || titleError["default"];
    this.errorSubtitle = subtitleError[`${codeResp}`] || subtitleError["default"];
    const btnError = codeResp === 105 ? this.$t("bulkBooking.create.btnUploadAgain") : this.$t("bulkBooking.create.btnReload")
    this.btnModalFailed =
        statusCode
        ? this.$t("bulkBooking.create.btnUnderstand")
        : btnError;
    this.btnModalCancel = codeResp === 105 ? this.$t("bulkBooking.create.btnBack") : "";

    this.resultErrorUpload = true;
    this.errorCode = codeResp;
  }

  resetForm() {
    const reset = {
      type: "Bulk Booking",
      activityName: "",
      archiveFile: "",
      clientName: "",
      formatTemplate: "",
    };
    BulkBookingController.setFormAddBulkBooking(reset);
    BulkBookingController.setStatusClearFile(false);
  }

  closePageUploadBulkBooking() {
    this.$router.push("/shipment/bulk/bulk-v2");
  }

  onCloseUploadBulkBooking() {
    this.resultErrorUpload = false;
  }

  onSubmitFailedUploadBulkBooking() {
    this.resultErrorUpload = false;

    if (this.errorCode === 105) {
      const fileInput = document.querySelector('input[type="file"]') as HTMLInputElement | null;
      fileInput?.click();
    }
  }
}
